import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class RetailBillingGuard {
  constructor(
    private router: Router,
    private appConfig: AppConfigService,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.appConfig.config$.pipe(
      map((config) => config?.userCanAccessRetailBilling || this.router.createUrlTree(['dashboard'])),
    );
  }
}
